module.exports = __webpack_public_path__ + "static/media/Trebuchet MS.54e1c73d.ttf";